import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { z } from 'zod'
import { axiosInstance } from '../axios-instance'
import {
  forgotPasswordShape,
  loginShape,
  userCreateShape,
  userShape,
  userShapeWithToken,
} from './models'

const login = createCustomServiceCall({
  inputShape: loginShape,
  outputShape: userShapeWithToken,
  cb: async ({ client, input, utils }) => {
    const res = await client.post('/login/', utils.toApi(input))
    return utils.fromApi(res.data)
  },
})

const signup = createCustomServiceCall({
  inputShape: userCreateShape,
  outputShape: userShapeWithToken,
  cb: async ({ client, input, utils }) => {
    const res = await client.post('/users/', utils.toApi(input))
    return utils.fromApi(res.data)
  },
})

const logout = createCustomServiceCall(async ({ client }) => {
  return client.post(`/logout/`)
})

const requestPasswordReset = createCustomServiceCall({
  inputShape: forgotPasswordShape,
  cb: async ({ client, input }) => {
    await client.post(`/password/reset/`, input)
  },
})

const resetPassword = createCustomServiceCall({
  inputShape: { userId: z.string(), token: z.string(), password: z.string() },
  outputShape: userShape,
  cb: async ({ client, input, utils }) => {
    const { token, user_id, ...rest } = utils.toApi(input)
    const res = await client.post(`/password/reset/confirm/${user_id}/${token}/`, rest)
    return utils.fromApi(res.data)
  },
})

const getGoogleOAuthUrl = createCustomServiceCall({
  outputShape: {
    auth_url: z.string(),
  },
  cb: async ({ client }) => {
    const response = await client.get(`/google-oauth/redirect-url/`)
    return response.data
  },
})

const saveGoogleOAuthToken = createCustomServiceCall({
  inputShape: {
    code: z.string().optional(),
    state: z.string().optional(),
  },
  cb: async ({ client, input, utils }) => {
    const response = await client.post('/google-oauth/code/', utils.toApi(input))
    return response.data
  },
})

const revokeGoogleOAuthToken = createCustomServiceCall({
  outputShape: {
    message: z.string(),
    user_id: z.string(),
  },
  cb: async ({ client }) => {
    const response = await client.delete('/google-oauth/revoke/')
    return response.data
  },
})

export const userApi = createApi({
  client: axiosInstance,
  baseUri: '/users/',
  models: {
    entity: userShape,
  },
  customCalls: {
    login,
    logout,
    requestPasswordReset,
    resetPassword,
    signup,
    getGoogleOAuthUrl,
    saveGoogleOAuthToken,
    revokeGoogleOAuthToken,
  },
})
const organizationFilterShape = {
  search: z.string(),
  hasProperties: z.string(),
}

export const organizationApi = createApi({
  client: axiosInstance,
  baseUri: '/organizations/',
  models: {
    entity: {
      id: z.string(),
      name: z.string(),
      defaultCurrency: z.string(),
      country: z.string().nullable().optional(),
      isBeta: z.boolean().optional(),
    },
    extraFilters: organizationFilterShape,
  },
})
